import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import Section from './Section';
import { projects } from '../../data/profile';

export default function Projects() {
    return (
        <Section id="proyectos" eyebrow="Trabajo reciente" title="Proyectos">
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
                {projects.map((p) => (
                    <Paper key={p.title} variant="outlined" sx={{
                        p: 3, display: 'flex', flexDirection: 'column', transition: 'border-color .2s, transform .2s',
                        '&:hover': { borderColor: 'primary.main', transform: 'translateY(-2px)' },
                    }}>
                        <Typography variant="h6">{p.title}</Typography>
                        <Typography color="text.secondary" sx={{ mt: 1, mb: 2.5, lineHeight: 1.7, flexGrow: 1 }}>
                            {p.description}
                        </Typography>
                        <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1 }}>
                            {p.tags.map((t) => (
                                <Chip key={t} label={t} size="small" sx={{ bgcolor: 'rgba(13,148,136,0.1)', color: 'primary.dark', fontWeight: 600 }} />
                            ))}
                        </Stack>
                    </Paper>
                ))}
            </Box>
        </Section>
    );
}
